/**
 * Created by dbrunwasser on 1/17/2017.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import gtn from './GTNexus.Common';
import Doc from './react/doc';

// Initial page load
function onLoad(url) {
    loadPage(url, false);

    console.time('myStart');
    DevNetMenu.apply( $('.tree-panel') );
    console.timeEnd('myStart');
}

// Loads the AXML document in the page based on the given URL
// 'history' argument is whether or not to add to the browser history
function loadPage(url, history) {
    if(url.indexOf('?') > -1 ){
        url = url.substring(0 , url.indexOf('?') )
    }
    if(history)
        gtn.currentHash = null;

    if( gtn.ui.axml.sourceUrl != url ){
        gtn.ui.axml.sourceUrl = url;
        if(history) {
            window.history.pushState(null, null, url);
        }
        if(document.getElementById('root')) {
            console.time('docTime');
            ReactDOM.render(React.createElement(Doc, { url: url }), document.getElementById('root'));
            console.timeEnd('docTime');
        } else {
            location.href = url;
        }
    }
    //for mobile, build breadcrumb on page changes
    if(isMobileRender)
        buildBreadcrumbNav();
}

// When the user goes back or forward, load the new page
window.onpopstate = function(e) {
    console.log('on pop state');
    loadPage(window.location.pathname, false);
};

function scrollToTop() {
    var timeOut;
    if (document.body.scrollTop!=0 || document.documentElement.scrollTop!=0){
        window.scrollBy(0,-50);
        //timeOut=setTimeout('scrollToTop()',10);
        timeOut=setTimeout( scrollToTop , 10 );
    }
    else clearTimeout(timeOut);
}

/*
    Essentially a light-weight Soho Application Menu component - application menu component
    is bulky and slow especially on mobile - this applies the same concepts/css styling while
    stripping all the unnecessary jquery events, etc that weren't being used
 */
var DevNetMenu = function () {
    //this.accordion();

    //Add Top-Level Icons
    var headers = this.find('.accordion.panel > .accordion-header');
    headers.each(function(){
        var $header = $(this);
        var $panes = $header.next('.accordion-pane');
        if($panes.length) {
            $header.addClass('has-chevron');
            let $btn = $('<button class="btn" type="button"></button>')
                .append('<svg class="chevron icon" focusable="false" aria-hidden="true" role="presentation"><use xlink:href="#icon-caret-down"></use></svg>')
                .append('<span class="audible">Expand</span>');
            //Panes have height 34px and 10 padding
            $header.append($btn);
            //build sub-headers
            buildSublists($panes);
        }
        $header.click( headerClickFn.bind(this, $panes));
    });
    let $thisAppMenu = this;
    //Set transitions for opening/closing panels
    this.find('.accordion-pane').each(function() {
        $(this).css('transition' , 'height 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94)');
        $(this).on('transitionend' , function(){
            var $this = $(this);
            if( $this.hasClass('is-expanded'))
                $this.css('height', 'auto');
            $($thisAppMenu).trigger('menu-height:change');
        });
    });

    //Control navigation
    $(this).find('.accordion-header > a').click(function(e) {
        if($(this).attr('href')) {
            e.preventDefault();
            loadPage( $(this).attr('href'), true);
            if(isMobileRender) {
                conditionallyHideMobileMenu(this);
            }
        }
    });

    //IF we have a path on website load, make sure the correct menu panel is visible
    let pageAnchor = this.find('.accordion-header > a[href="' + location.pathname + '"]');
    if(pageAnchor.length) {
        let pageAnchorContainct = pageAnchor.parent();
        let prevPanels = pageAnchorContainct.parents('.accordion-pane');
        //Is Top Level
        if(prevPanels.length > 0) {
            prevPanels.get().reverse().forEach(function (panel) {
                let header = $(panel).prev('.accordion-header');
                header.find('> button').click(); // select icon button - which will be expanding button
                header.removeClass('is-selected');
            });
        }
        pageAnchorContainct.addClass('is-selected');
        setTimeout( function(){
            var posHeight = pageAnchorContainct.position().top;
            var bodyHeight = $('body').height() - 28 ; //28px footer
            if( posHeight > bodyHeight ){
                $('.accordion.panel').animate({ scrollTop : posHeight - (bodyHeight / 2 ) } , '200' );
            }
        }, 1000 )
    }

    //wire up application-menu for mobile
    if( isMobileRender === 'true' ) {
        buildMobileAppMenu(this, $('.application-menu-trigger') );
    }

    function buildSublists( panels ) {
        panels.find('> .accordion-header').each(function(){
            let myPanel = $(this);
            let subPanels = myPanel.next('.accordion-pane');
            if(subPanels.length) {
                let $expandBtn = $('<button class="btn" type="button"></button>')
                    .append('<span class="icon plus-minus" aria-hidden="true" role="presentation"></span>')
                    .append('<span class="audible">Expand</span>');
                myPanel.prepend($expandBtn);
                buildSublists(subPanels);
            }
            myPanel.click( headerClickFn.bind(this,subPanels));
        })
    }

    function headerClickFn(panes,e) {
        $('.accordion-header').removeClass('is-selected');
        $(this).addClass('is-selected');
        if(panes.length) {
            expandOnClickFn.apply(this,[panes,e]);
        }
    }

    function expandOnClickFn(paneEl,e,e2,e3) {
        paneEl = $(paneEl);
        let maxHeight = estimatePanelHeight(paneEl);
        //If not top level, subtract ten
        if(paneEl.parent('.accordion.panel').length === 0) {
            maxHeight = maxHeight - 10;
        }
        paneEl.siblings('.accordion-pane.is-expanded').each( function() {
            expandOnClickFn(this);
        });
        //Collapse other expanded panels
        paneEl.toggleClass('is-expanded');
        //Expand
        if (paneEl.hasClass('is-expanded')) {
            paneEl.css('height', maxHeight + "px");
            paneEl.prev('.accordion-header').find('> button use').attr('xlink:href', '#icon-caret-up');
        } else {
            paneEl.get(0).style.height = maxHeight + "px";
            setTimeout( function() {  paneEl.css('height', 0); } , 50 );
            paneEl.prev('.accordion-header').find('> button use').attr('xlink:href', '#icon-caret-down');
        }
        paneEl.prev('.accordion-header').find('> button span.icon').toggleClass('active');
        $('.tree-panel').find('#menuContactBtn').css({'visibility' : 'hidden'});
    }

    function estimatePanelHeight( $pane ) {
        return $pane.find('> .accordion-header').length * 34 + 10;
    }

    function buildMobileAppMenu(appMenu, trigger ) {
        trigger.click( handleMobileAppMenuClick );
        appMenu.find('> .panel.accordion').css('height', 'calc(100% - 60px)');
        $('#appMenuCloseBtn').click( handleMobileAppMenuClick );
        appMenu.on('open-app-menu', mobileAppMenuOpenHandler.bind(appMenu));
        appMenu.on('close-app-menu', mobileAppMenuCloseHandler.bind(appMenu));
        //For apple event propagation
        appMenu.on('touchmove', function(e) {
            if(e.target.tagName === 'NAV' || e.target.className === 'accordion panel') {
                e.preventDefault();
            } else {
                e.stopPropagation();
            }
        });
        appMenu.on('gesturestart', function(e) {
            e.stopPropagation();
        });
        //Add Contact US button
        let contactUrl = "'/user/ask-an-evangelist'";
        var contactUsBtn = $('<div class="mobile-button-bar">').css({'position': 'absolute', 'bottom' : 0})
            .append('<input type="button" id="menuContactBtn" onclick="location.href=' + contactUrl + '" value="Contact Us"/>');
        appMenu.find('> .panel.accordion').append(contactUsBtn);
        $('.accordion-header a[href="/blog"]').removeAttr('href');
        var screenSize = $('body').height();
        //Is the accordion height > doc height - if yes, re-position contact Us button
        appMenu.on('menu-height:change' , function(e) {
            setTimeout( function() {
                let heightVal = 270; // 6 accordion headers * 45px each, as defined in css
                appMenu.find('.accordion.panel > .accordion-pane').each( function() {
                    heightVal += $(this).height();
                });
                if( heightVal > screenSize )
                    contactUsBtn.css('position', 'static');
                else
                    contactUsBtn.css('position', 'absolute');
                contactUsBtn.find('> input').css('visibility', 'visible');
            }, 5 );
        });
    }

    function conditionallyHideMobileMenu( anchorEl ) {
        //Hide menu if not an expandable tree panel
        if( $(anchorEl).siblings('button.btn').length === 0 ) {
            $('#appMenuCloseBtn').click();
        }
    }

    function handleMobileAppMenuClick() {
        let appMenu = $('nav');
        appMenu.toggleClass('is-open');
        if(appMenu.hasClass('is-open')) {
            appMenu.trigger('open-app-menu');
        } else {
            appMenu.trigger('close-app-menu');
        }
    }

    function mobileAppMenuOpenHandler() {
        let docHeight = Math.max($('body').height(), $('.m-main-content').height()) + "px";
        let overlay = $('<div/>')
            .attr('id' , 'appx-mobile-overlay')
            .css({ height : docHeight, width : '100%', 'background-color' : 'black', opacity : '0.5', top : 0, position : 'absolute' })
            .on('touchmove', (e) => {
                e.preventDefault();
            })
            .one('click' , handleMobileAppMenuClick );
        $('.article-panel').append(overlay).css({'overflow-y': 'hidden', 'height' : '100vh'});

    }

    function mobileAppMenuCloseHandler(){
        $('#appx-mobile-overlay').remove();
        $('.article-panel').css({'overflow-y' : 'auto' , 'height' : 'auto' });
    }
};

function buildBreadcrumbNav() {
    let breadcrumbContainer = $('.breadcrumb-container').empty();
    let paths = location.pathname.substring(1).split('/');
    let i = 0;
    function breadCrumbLabel(path) {
        let label = path.replace(/-/g , ' ');
        return label.split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
    }

    if(paths.length > 1 ){
        for(i; i<paths.length;i++) {
            let label = breadCrumbLabel(paths[i]);
            let myEl = $('<a>' + label + '</a>');
            let hrefVal = "/" + paths.slice(0,i+1).join('/');
            if(i !== paths.length -1 && $('.accordion-header a[href="' + hrefVal + '"]').length ) {
                myEl.attr('href' , hrefVal);
            }
            breadcrumbContainer.append(myEl);
        }
    }

}

window.onLoad = onLoad;
window.initAppMenu = DevNetMenu;


// WEBPACK FOOTER //
// ./public/javascripts/GTNexus.Soho.js